const API = {
    ActiveUserByID: "GetActiveUserDetailsByID",
    GetActiveUsers: "GetActiveUsers",
    DeleteUser: "DeleteUser",
    ResetPassword: "ResetPassword",
    UserStatus: "UserStatus",
    GetUserPhoto: "GetUserPhoto",
    CreateUser: "CreateUser",
    EditUser: "EditUser",
    UploadUserPhoto: "UploadUserPhoto",
    GetActivatedUsers: "GetActivatedUsers"
}

export default API;